/**
 * Класс для работы с мобильным меню.
 */
class MobileNav {

    constructor() {
        this.init();
    }

    init() {
        this.openMenu();
        this.closeMenu();
    }

    openMenu() {
        document.querySelectorAll('.menu-burger').forEach(button => {
            button.addEventListener('click', () => {
                document.querySelector('.mobile-nav').classList.add('active');
                document.body.style.overflow = 'hidden';
            });
        });

    }

    closeMenu() {
        document.querySelectorAll('.mobile-nav__close').forEach(close => {
            close.addEventListener('click', () => {
                document.querySelector('.mobile-nav').classList.remove('active');
                document.body.style.overflow = 'auto';
            });
        });
    }
}

export default MobileNav;